customElements.get("ugc-component") || customElements.define("ugc-component", class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const e = this.querySelector("[data-slider]");
    if (!e) return;
    const {covetType: t, galleryEmbedId: o, productHandle: n, limit: r} = this.dataset, i = window.Shopify?.shop, s = document.createElement("template");
    s.innerHTML = '\n          <li class="relative overflow-hidden h-auto w-auto shrink-0 snap-start gap-gutter" data-slide>\n            <a class="group relative block h-full" target="_blank" rel="noopener">\n              <img class="block w-grid h-full object-cover" loading="lazy" role="presentation">\n              <div\n                class="pointer-events-none absolute left-3 top-3 right-3 inline-block\n                      px-2 py-1 text-xs \n                      text-scheme-text bg-scheme-background \n                      whitespace-nowrap overflow-hidden text-ellipsis\n                      opacity-0 transition-opacity duration-200\n                      group-hover:opacity-100"\n              ></div>\n            </a>\n          </li>\n        ';
    const c = Number(r) || 12;
    let l = null;
    "gallery" === t && o ? l = `https://shopify.covet.pics/api/v1/embed/${o}` : "product" === t && n && i && (l = `https://shopify.covet.pics/api/v1/shop/${i}/product/${n}`), 
    l && fetch(l).then(e => {
      if (!e.ok) throw new Error("Network error");
      return e.json();
    }).then(t => {
      e.innerHTML = "", (t.items || []).filter(e => "video" !== e.data_type && e.images).slice(0, c).forEach(t => {
        const o = s.content.cloneNode(!0), n = o.querySelector("a"), r = o.querySelector("img"), i = o.querySelector("div");
        r.src = t.images?.medium_resolution || t.cover_images?.medium_resolution || "", 
        t.url ? n.href = t.url : n.removeAttribute("href"), t.caption ? i.textContent = t.caption : i.remove(), 
        e.appendChild(o);
      }), this.classList.remove("hidden");
      const o = this.querySelector("slider-component");
      o?.refresh?.();
    }).catch(e => {
      console.error("Covet API error:", e);
    });
  }
});